import { useState } from "react";
import axios from "axios";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKAlert from "components/MKAlert";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/examples/content-5.jpg";
import bgImage1 from "assets/images/examples/content-4.jpg";

//icons
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-router-dom";

//motion
import { motion } from "framer-motion";

function ContactUs() {
  // server from env
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  //vars declaration
  const [alertMsg, setAlertMsg] = useState("");
  const [names, setNames] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  //--- function to handle submit ---
  const handleContact = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSent(false);
    const data = JSON.stringify({
      names: names,
      email: email,
      phone: phone,
      message: message,
    });

    axios
      .post(SERVER_URL + "/contact/post/", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data === "Contacted" && res.status === 200) {
          //window.scrollTo({ top: 0, behavior: "smooth" });
          setAlertMsg("Email Sent!, We'll Get Back to You Very Soon");
          setIsSent(true);
        } else {
          //window.scrollTo({ top: 0, behavior: "smooth" });
          alert("BYANZE, Subscription Yawe");
        }
      })
      .catch((err) => {
        //window.scrollTo({ top: 0, behavior: "smooth" });
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <>
      <>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/booking",
            label: "BOOK NOW",
            color: "info",
          }}
          transparent
          light
        />
        <MKBox
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={8}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={{ mx: "auto", textAlign: "center" }}
            >
              <MKTypography
                variant="h2"
                color="white"
                mb={2}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Reach Out — Your Comfort Is Our Priority
              </MKTypography>
              <MKTypography variant="body1" color="white" mb={4}>
                Reinforces the care-driven nature of your services.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Card
          sx={{
            p: 2,
            mx: { lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
            overflow: "hidden",
          }}
        >
          <MKBox component="section" py={{ xs: 0, lg: 6 }}>
            <Container>
              <Grid container item px={6}>
                <MKBox
                  width="100%"
                  bgColor="white"
                  borderRadius="xl"
                  shadow="xl"
                  mb={6}
                  sx={{ overflow: "hidden" }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} lg={7}>
                      <MKBox component="form" p={2} role="form" onSubmit={handleContact}>
                        <MKBox px={3} py={{ xs: 2, sm: 6 }}>
                          {alertMsg.length > 0 && (
                            <motion.div
                              initial={{ x: -200, opacity: 0 }}
                              animate={{ x: 0, opacity: 1 }}
                              transition={{ duration: 1.5, ease: "easeOut" }}
                            >
                              <MKAlert color="info">{alertMsg}</MKAlert>
                            </motion.div>
                          )}

                          <MKTypography variant="h2" mb={1}>
                            Get in Touch
                          </MKTypography>
                          <MKTypography variant="body1" color="text" mb={2}>
                            We&apos;ll get back to you as soon as possible.
                          </MKTypography>
                        </MKBox>
                        <MKBox pt={0.5} pb={3} px={3}>
                          <Grid container>
                            <Grid item xs={12} pr={1} mb={3}>
                              <MKInput
                                onChange={(e) => setNames(e.target.value)}
                                variant="standard"
                                label="Full Name"
                                placeholder="Names here..."
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} pr={1} mb={3}>
                              <MKInput
                                onChange={(e) => setPhone(e.target.value)}
                                variant="standard"
                                label="Telephone"
                                placeholder="Phone..."
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} pr={1} mb={3}>
                              <MKInput
                                onChange={(e) => setEmail(e.target.value)}
                                variant="standard"
                                label="Email"
                                placeholder="Email here..."
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} pr={1} mb={3}>
                              <MKInput
                                onChange={(e) => setMessage(e.target.value)}
                                variant="standard"
                                label="Your message"
                                placeholder="Message here..."
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                multiline
                                rows={6}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            item
                            xs={12}
                            md={6}
                            justifyContent="flex-end"
                            textAlign="right"
                            ml="auto"
                          >
                            <MKButton
                              variant="gradient"
                              color={isSent ? "info" : "primary"}
                              type="submit"
                              fullWidth
                              disabled={isLoading || isSent}
                            >
                              {isLoading
                                ? "Sending Email..."
                                : isSent
                                ? "Email Sent"
                                : "Send Message"}
                            </MKButton>
                          </Grid>
                        </MKBox>
                      </MKBox>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={5}
                      position="relative"
                      px={0}
                      sx={{
                        backgroundImage: ({
                          palette: { gradients },
                          functions: { rgba, linearGradient },
                        }) =>
                          `${linearGradient(
                            rgba(gradients.info.main, 0.8),
                            rgba(gradients.info.state, 0.8)
                          )}, url(${bgImage1})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <MKBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="100%"
                        textAlign="left"
                      >
                        <MKBox py={6} px={{ xs: 4, sm: 8 }} my="auto" width="100%" maxWidth="420px">
                          <MKTypography variant="h3" color="white" mb={1}>
                            Other Ways to Reach Us
                          </MKTypography>

                          <MKTypography variant="body2" color="white" opacity={0.8} mb={3}>
                            You can also get in touch with us through the contacts below. Our team
                            will respond as quickly as possible.
                          </MKTypography>

                          {/* Contact Lines */}
                          {[
                            {
                              icon: <PhoneIcon sx={{ color: "#fff" }} />,
                              text: "(+250) 79530 5418",
                            },
                            {
                              icon: <EmailIcon sx={{ color: "#fff" }} />,
                              text: (
                                <>
                                  info@helpereverywhere.com
                                  <br />
                                  helpereverywheremail@gmail.com
                                </>
                              ),
                            },
                            {
                              icon: <LocationOnIcon sx={{ color: "#fff" }} />,
                              text: "KG 314 St, Kigali, Rwanda",
                            },
                          ].map((item, i) => (
                            <MKBox
                              key={i}
                              display="flex"
                              alignItems="flex-start"
                              gap={2}
                              p={0.5}
                              mb={0.5}
                            >
                              {item.icon}
                              <MKTypography
                                component="span"
                                variant="button"
                                color="white"
                                opacity={0.8}
                                fontWeight="regular"
                                lineHeight={1.6}
                              >
                                {item.text}
                              </MKTypography>
                            </MKBox>
                          ))}

                          {/* Careers Link */}
                          <MKBox display="flex" alignItems="center" gap={2} p={0.5} mt={1}>
                            <WorkIcon sx={{ color: "#fff" }} />
                            <MKTypography
                              component={Link}
                              to="/employee"
                              variant="button"
                              color="white"
                              opacity={0.9}
                              fontWeight="medium"
                              sx={{
                                textDecoration: "none",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  color: "#00BFFF",
                                  transform: "translateX(4px)",
                                },
                              }}
                            >
                              Careers
                            </MKTypography>
                          </MKBox>

                          {/* Social Icons */}
                          <MKBox mt={3} display="flex" gap={1}>
                            <MKButton
                              variant="text"
                              color="white"
                              size="large"
                              iconOnly
                              component="a"
                              href="https://wa.me/250795305418"
                              target="_blank"
                            >
                              <WhatsAppIcon sx={{ fontSize: "1.25rem", color: "white" }} />
                            </MKButton>
                            <MKButton
                              variant="text"
                              color="white"
                              size="large"
                              iconOnly
                              component="a"
                              href="https://facebook.com/helpereverywhere"
                              target="_blank"
                            >
                              <FacebookIcon sx={{ fontSize: "1.25rem", color: "white" }} />
                            </MKButton>
                            <MKButton
                              variant="text"
                              color="white"
                              size="large"
                              iconOnly
                              component="a"
                              href="https://instagram.com/helpereverywhere"
                              target="_blank"
                            >
                              <InstagramIcon sx={{ fontSize: "1.25rem", color: "white" }} />
                            </MKButton>
                          </MKBox>
                        </MKBox>
                      </MKBox>
                    </Grid>
                  </Grid>
                </MKBox>
              </Grid>
            </Container>
          </MKBox>
        </Card>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </>
    </>
  );
}

export default ContactUs;
